import { RootState, useAppSelector } from "../../../app/store";
import React, {forwardRef} from "react";
import DocumentTooltip from "../../documentManagement/components/DocumentTooltip";
import { cn } from "../../../lib/utils";


interface SidebarFeatureGateButtonProps  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  onClick: () => void;
  isSelected: boolean;
  icon: React.ReactNode;
  selector: (state: RootState) => boolean;
  disabledMessage?: string;
  className?: string;
}

const SidebarFeatureGateButton= forwardRef<HTMLButtonElement, SidebarFeatureGateButtonProps>(
({
  onClick,
  isSelected,
  icon,
  selector,
  disabledMessage,
  className,
  ...rest
},ref) => {

  const isEnabled = useAppSelector(selector);
  const isDisabled = !isEnabled; 

  const button = (
    <button
      ref={ref}
      onClick={onClick}
      disabled={isDisabled}
      className={cn(
        `
        h-8 w-8
        flex items-center justify-center
        rounded-md
        transition-colors
        `,
        isSelected
          ? "bg-indigo-50"
          : "hover:bg-gray-100 bg-transparent",
        className,
      )}
      {...rest}
    >
      {icon}
    </button>
  );

  if (isDisabled) {
    return (
      <DocumentTooltip content={disabledMessage || "Not available"}>
        <span className="inline-flex">{button}</span>
      </DocumentTooltip>
    );
  }

  return button
});

export default SidebarFeatureGateButton;
